module.exports = __webpack_public_path__ + "static/media/rentLedgerAlert.740006a7.png";